import routeCodes from 'common/constants/route-codes';

import * as types from './types';
import { dishesSteps } from '../../common/constants/menu';

const initialState = {
  listData: {
    id: 'special-menu',
    title: 'I tuoi menù speciali',
    description:
      'Crea e modifica i tuoi menù speciali.',
    href: routeCodes.specialMenuEdit,
    createLink: routeCodes.specialMenuCreate,
    loading: false,
    items: [],
  },
  itemLoading: true,
  currentItem: {},
  deleteInProcess: false,
  errors: null,
  listFetched: false,
  createOrUpdateInProcess: false,
  formStep: dishesSteps.first,
  completedSteps: [dishesSteps.first],
};

const specialMenuReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SPECIAL_MENU_GET_FAILURE:
      return {
        ...state,
        listData: {
          ...state.listData,
          loading: false,
        },
      };
    case types.RESET_SPECIAL_MENU_LIST_DATA:
      return {
        ...state,
        listFetched: false,
        listData: {
          id: 'special-menu',
          title: 'I tuoi menù speciali',
          description:
            'Crea e modifica i tuoi menù speciali.',
          href: routeCodes.specialMenuEdit,
          createLink: routeCodes.specialMenuCreate,
          loading: false,
          items: [],
        },
      };
    case types.SPECIAL_MENU_GET_REQUEST:
      return {
        ...state,
        listData: {
          ...state.listData,
          loading: true,
        },
      };
    case types.SPECIAL_MENU_GET_SUCCESS:
      return {
        ...state,
        listFetched: true,
        listData: {
          ...state.listData,
          loading: false,
          items: action.payload,
        },
      };
    case types.CHANGE_SPECIAL_MENU_FORM_STEP:
      return {
        ...state,
        formStep: action.payload.step,
        completedSteps: action.payload.completedSteps,
      };
    case types.RESET_SPECIAL_MENU_ERRORS:
      return {
        ...state,
        errors: null,
      };
    case types.SPECIAL_MENU_GET_BY_ID_FAILURE:
      return {
        ...state,
        itemLoading: false,
      };
    case types.SPECIAL_MENU_GET_BY_ID_REQUEST:
      return {
        ...state,
        itemLoading: true,
      };
    case types.SPECIAL_MENU_GET_BY_ID_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        currentItem: action.payload,
      };
    case types.SPECIAL_MENU_CREATE_OR_UPDATE_REQUEST:
      return {
        ...state,
        createOrUpdateInProcess: true,
      };
    case types.SPECIAL_MENU_CREATE_OR_UPDATE_FAILURE:
      return {
        ...state,
        errors: action.payload,
        createOrUpdateInProcess: false,
      };
    case types.SPECIAL_MENU_CREATE_OR_UPDATE_SUCCESS:
      return {
        ...state,
        createOrUpdateInProcess: false,
      };
    case types.SPECIAL_MENU_DELETE_REQUEST:
      return {
        ...state,
        deleteInProcess: true,
      };
    case types.SPECIAL_MENU_DELETE_SUCCESS:
    case types.SPECIAL_MENU_DELETE_FAILURE:
      return {
        ...state,
        deleteInProcess: false,
      };
    case types.SPECIAL_MENU_CHANGE_POSITION_SUCCESS: {
      const { items } = state.listData;
      const { position, originalPosition } = action.payload;

      const newItems = Array.from(items);
      const [removed] = newItems.splice(originalPosition, 1);
      newItems.splice(position, 0, removed);

      return {
        ...state,
        listData: {
          ...state.listData,
          items: newItems,
        }
      };
    }
    default:
      return state;
  }
};

export default specialMenuReducer;
